import { useTranslation } from "@opendash/i18n";
import { Icon } from "@opendash/icons";
import { Tag, Tooltip } from "antd";
import dayjs from "dayjs";
import React from "react";
import { useTicketData } from "../..";

type Props = {
  asIcon?: boolean;
};
export const DuedateTag = (props: Props) => {
  const t = useTranslation();
  const ticketData = useTicketData();

  if (!ticketData.duedate) return <></>;

  const isOverdue = dayjs(ticketData.duedate.get("end")) < dayjs();
  const isSoon =
    dayjs(ticketData.duedate.get("end")).subtract(7, "days") < dayjs();

  const text = isOverdue
    ? t("maintenance:ticket.state.overdue")
    : t("maintenance:ticket.state.duedate");

  const icon = isOverdue ? "fa:exclamation-circle" : "fa:clock";
  const color = isOverdue ? "red" : isSoon ? "#f5871f" : undefined;

  if (props.asIcon) {
    return (
      <Tooltip title={text}>
        <Icon icon={icon} style={{ color }} />
      </Tooltip>
    );
  }

  return (
    <Tooltip title={text}>
      <Tag icon={<Icon icon={icon} />} color={color}>
        {text}
      </Tag>
    </Tooltip>
  );
};
